<template>
  <div class="container">
    <w-navbar v-show="iosOrAndroidShow" nav_title="当前状态" :icon="'iconchevron-left'" :cvShow="true" @mobileLeftBtn="leftBtnClick"/>
    <div class="content">
      <p class="title">您当前的求职状态是</p>
      <p class="other">您可以在求职设置中修改您的求职偏好</p>
      <div class="option-item" :class="{'active':selectIndex=='离职，随时到岗'}" @click="handleClickType('离职，随时到岗')" data-growing-container>
        离职，随时到岗
      </div>
      <div class="option-item" :class="{'active':selectIndex=='在职，看看机会'}" @click="handleClickType('在职，看看机会')" data-growing-container>
        在职，看看机会
      </div>
      <div class="option-item" :class="{'active':selectIndex=='在职，暂不考虑'}" @click="handleClickType('在职，暂不考虑')" data-growing-container>
        在职，暂不考虑
      </div>
    </div>
    <div class="btn-next" @click="handleClickNext" :style="{background:selectIndex?'#FF6644':'#CFCFCF'}">下一步
    </div>
  </div>
</template>

<script>
  import WNavbar from "@/components/global/w-navbar";
  import {envMixin} from "@/assets/js/mixin/global";
  import {componentsMixin} from "../../assets/js/mixin/components";
  import intention from "../../api/api-list/intention";
  import {mapActions, mapState} from "vuex";

  const textList = ["离职，随时到岗", "在职，看看机会", "在职，暂不考虑"]
  export default {
    name: "workplace_work_type",
    data() {
      return {
        //选中的标签
        selectIndex: ''
      }
    },
    components: {WNavbar},
    methods: {
      ...mapActions('user', ['getUserIntention']),
      //返回
      leftBtnClick() {
        this.$router.back();
      },
      //选中
      handleClickType(type) {
        this.selectIndex = type
      },
      //下一步
      async handleClickNext() {
        if (!this.selectIndex) return
        try {
          let res = await intention.updateIntentions({expect_status: this.selectIndex})
          if (res.code === 1000) {
            this.getUserIntention()
            await this.$router.push("/job/intentions")
          } else {
            this.showToast(res.message, 1000)
          }
        } finally {

        }
      }
    },
    created() {
      this.selectIndex = this.userIntention.expect_status
    },
    computed: {
      ...mapState('user', ['userIntention'])
    },
    mixins: [envMixin, componentsMixin]
  }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/global/variable';
  .container {
    height: 100vh;
    position: relative;
    box-sizing: border-box;

    .btn-next {
      width: 327px;
      height: 42px;
      border-radius: 4px;
      color: #fff;
      text-align: center;
      position: absolute;
      left: 24px;
      bottom: 18px;
      line-height: 42px;
    }
  }

  .content {
    padding: 88px 24px 0 24px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
      font-weight: 500;
      color: rgba(64, 64, 64, 1);
      margin-bottom: 8px;
    }

    .other {
      font-size: 14px;
      font-weight: 300;
      color: rgba(156, 156, 156, 1);
      margin-bottom: 48px;
    }

    .option-item {
      width: 100%;
      height: 46px;
      border-radius: 23px;
      text-align: center;
      line-height: 46px;
      color: $color-dark-gray;
      border: 1px solid #ececec;
      margin-bottom: 16px;

      &.active {
        color: $color-theme;
        border-color: $color-theme;
      }
    }

    .internship {
      height: 108px;
      background: rgba(255, 246, 244, 1);
      border-radius: 4px;
      margin-bottom: 16px;
      padding: 24px;

      .internship-day {
        display: flex;
        justify-content: space-between;
        margin-bottom: 32px;

        .internship-day-title {
          color: #FF6644;
          font-size: 14px;
          font-weight: 400;
        }

        .internship-day-operation {
          width: 73px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          > span {
            color: #FF6644;
            font-size: 14px;
          }

          & > i {
            font-size: 18px;
            color: #FF6644;

            &.disabled {
              color: #FFD1C7;
            }
          }
        }
      }

      .internship-month {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #FF6644;
      }

      .select-month {
        color: #FFC3B5;
      }

      .margin-16 {
        margin-right: 16px;
      }
    }
  }

</style>